
























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import chunk from 'lodash/chunk'
import { getBoUrl } from '@/api/http-constants'
import { UserModule } from '@/store/modules/user'
import { ApiService } from '@/api/api.service'
import Alert from '@/components/Alert.vue'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import find from 'lodash/find'

interface IImage {
    placeholder: boolean
    id: number
    url: string
    thumbnailUrl: string
}

@Component({
    components: {
        Alert,
        SmoothReflow,
    },
})
export default class Album extends Vue {
    @Prop() private group: any

    images: IImage[] = []
    // images: IImage[] = [...Array(3).keys()].map(x => {
    //     return {
    //         placeholder: x === 0,
    //         id: x,
    //         url: 'https://unsplash.it/1200/768.jpg?image=' + (x + 250),
    //         thumbnailUrl: 'https://unsplash.it/600.jpg?image=' + (x + 250),
    //     }
    // })

    boUrl = getBoUrl()
    userID: number
    apiService = new ApiService()
    lightbox: any = null
    loaded = false
    MAX_IMAGES = 5

    get chunkedImages() {
        return chunk(this.images, this.MAX_IMAGES)
    }

    @Watch('group', { deep: true, immediate: true })
    async onGroup(group) {
        if (!group) {
            return
        }

        const imagesResp = await this.apiService.getGroupAlbums(
            this.group.group.id
        )
        const images = imagesResp.data

        const imagesGallery: IImage[] = images.map(image => {
            return {
                id: image.id,
                url: `${this.boUrl}/uploads/groups/${image.id}/${
                    image.imageName
                }`,
                thumbnailUrl: `${this.boUrl}/uploads/groups/${image.id}/${
                    image.imageName
                }`,
            }
        })

        this.images = imagesGallery
        this.loaded = true
    }

    @Watch('loaded')
    onLoaded() {
        if (!this.loaded) {
            return
        }
        requestAnimationFrame(() => {
            ;(<any>$('.popover-dismiss')).popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }

    @Watch('images', { deep: true, immediate: true })
    onImages() {
        this.refreshLightbox()
    }

    onAfterTransition() {
        this.refreshLightbox()
    }

    refreshLightbox() {
        requestAnimationFrame(_ => {
            if (this.lightbox) {
                this.lightbox.destroy()
            }

            const album = <any>$(this.$refs.album)
            this.lightbox = album.find('a').simpleLightbox({
                history: false, // nécessaire pour éviter une collision avec vue-router
            })
        })
    }

    async mounted() {
        this.userID = UserModule.userInfos.id
    }

    async onFileChange(e) {
        const formData = new FormData()
        formData.append('image', e.currentTarget.files[0])

        const temporaryID = new Date().getTime()
        this.images.push({
            placeholder: true,
            id: temporaryID,
            url: '',
            thumbnailUrl: '',
        })

        try {
            const resp = await this.apiService.postGroupImage(
                this.group.group.id,
                this.userID,
                formData
            )
            const message = resp.data

            if (message.success === false) {
                ;(<Alert>this.$refs.alert).handleAlert(
                    'danger',
                    message.message
                )

                const image = find(this.images, {
                    id: temporaryID,
                })
                this.images.splice(this.images.indexOf(image), 1)
            } else {
                ;(<Alert>this.$refs.alert).handleAlert(
                    'success',
                    message.message
                )

                const image = find(this.images, {
                    id: temporaryID,
                })
                image.placeholder = false
                image.id = this.parseImageId(message.image)
                image.url = `${this.boUrl}${message.image}`
                image.thumbnailUrl = `${this.boUrl}${message.image}`
            }
        } catch (e) {
            ;(<Alert>this.$refs.alert).handleAlert(
                'danger',
                'Fichier image invalide'
            )

            const image = find(this.images, {
                id: temporaryID,
            })
            this.images.splice(this.images.indexOf(image), 1)
        }
    }

    async onRemove(image) {
        console.log(JSON.parse(JSON.stringify(image)))
        await this.apiService.deleteGroupImage(image.id)

        const index = this.images.indexOf(image)
        this.images.splice(index, 1)
        ;(<Alert>this.$refs.alert).handleAlert(
            'success',
            'Image supprimée avec succés'
        )
    }

    parseImageId(imagePath: string): number {
        const parts = imagePath.split('/')
        const id = parseInt(parts[3], 10)
        return id
    }
}
